module.exports = __webpack_public_path__ + "media/images/background1-d03e5b6c0bbee68309300a71c11da64b.png";